import { reduxKey } from './constants';
export var getPopover = function (state, id) {
    var popover = (state[reduxKey] || []).find(function (item) { return item.id === id; });
    if (popover) {
        return {
            isOpen: true,
            params: popover.options.params,
        };
    }
    else {
        return {
            isOpen: false,
        };
    }
};
//# sourceMappingURL=selectors.js.map